module.exports = __webpack_public_path__ + "static/media/yes.5396075f.svg";